import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Stack, Typography } from "@mui/material";
import { type TFunction, useResource } from "Translations/Resources";

type OutcomeLine = {
  id: string;
  translationKey: Parameters<TFunction>[0];
};

type Variant = "lose" | "keep";

const VARIANT_CONFIG = {
  lose: { Icon: CloseIcon, color: "error" },
  keep: { Icon: CheckIcon, color: "success" },
} as const;

type Props = {
  variant: Variant;
  title: string;
  lines: Array<OutcomeLine>;
};

/** One side of the leave-program dialog: what the person loses, or what stays theirs. */
export const OptOutOutcomeColumn = ({ variant, title, lines }: Props) => {
  const { t } = useResource();
  const { Icon, color } = VARIANT_CONFIG[variant];

  return (
    <Box flex={1} p={2} border={1} borderColor="divider" borderRadius={2}>
      <Stack direction="row" gap={0.5} alignItems="center" mb={1}>
        <Icon fontSize="small" color={color} />
        <Typography fontWeight={600} color={`${color}.main`}>
          {title}
        </Typography>
      </Stack>
      <Stack gap={0.5}>
        {lines.map(({ id, translationKey }) => (
          <Typography key={id}>{t(translationKey)}</Typography>
        ))}
      </Stack>
    </Box>
  );
};
